import { ContactMethod, SocialPlatform } from 'src/constants/commonConstants';
// import { Product } from 'src/constants/schema';

// export const products: Product[] = [
//     {
//         id: '100024',
//         brand: 'Sanfe',
//         title: 'Instant Tan & Dead Skin Removal Gel - For Dead Skin, Tan & Dull Complexion',
//         images: [
//             {
//                 imageName: '100024-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Website',
//                 link: 'https://sanfe.in/collections/buy-5-products-for-999/products/sanfe-instant-tan-dead-skin-removal-exfoliating-gel',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100023',
//         brand: 'Samisha Organic',
//         title: 'Anti Dandruff Hair Spray. Relieves Scalp Itching & Flaking',
//         images: [
//             {
//                 imageName: '100023-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Website',
//                 link: 'https://samishaorganic.com/products/anti-dandruff-spray',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100022',
//         brand: 'YES GLOW',
//         title: 'Dark Spot Remover Face Wash Scrub Gel Cleanser - 100ml | With Kojic and Hyaluronic Acid | Soothing Aloe Vera | Removes Dark Spots and Helps Brighten Skin',
//         images: [
//             {
//                 imageName: '100022-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/42cqpRe',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100021',
//         brand: 'Charwee',
//         title: 'Charwee Dark Spot Remover Face Wash Scrub Gel Cleanser - 100ml | With Kojic and Hyaluronic Acid | Soothing Aloe Vera | Removes Dark Sports and Helps Brighten Skin',
//         images: [
//             {
//                 imageName: '100021-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/47xM6P8',
//             },
//             {
//                 title: 'Flipkart',
//                 link: 'https://www.flipkart.com/charwee-dark-spot-scrub-gel-cleanser/p/itm193c91a22c522',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100020',
//         brand: 'YES GLOW',
//         title: 'Dark Spot Corrector For Face - 60g | With Active Blend Alpha Arbutin, Kojic Acid and Niacinamide | Helps Reducing Dark Spots & Acne Marks | For A Refreshed and Brighter Skin',
//         images: [
//             {
//                 imageName: '100020-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/4n8xkmo',
//             },
//             {
//                 title: 'Flipkart',
//                 link: 'https://www.flipkart.com/yes-glow-dark-spot-corrector-face/p/itm9d58924511f91',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100019',
//         brand: 'Greenwell',
//         title: 'Greenwell 2% Kojic Acid Serum with Alpha Arbutin, Niacinamide & Hyaluronic Acid – Dark Spot Remover, Skin Brightening & Pigmentation Control – Face Serum for Glowing Skin',
//         images: [
//             {
//                 imageName: '100019-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/3JafMYi',
//             },
//             {
//                 title: 'Flipkart',
//                 link: 'https://www.flipkart.com/greenwell-2-kojic-acid-face-serum-alpha-arbutin-niacinamide-[…]-spot-pigmentation-removal-night-use-only/p/itma55b52fb88994',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100018',
//         brand: 'Botanical Beauty',
//         title: 'Premium Quality Moringa Face Oil. Cold-pressed oil extracted from Moringa seeds, rich in antioxidants, vitamins A and C, and essential fatty acids',
//         images: [
//             {
//                 imageName: '100018-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/46v3nb7',
//             },
//             {
//                 title: 'Website',
//                 link: 'https://www.botanicalbeautyproducts.com/product-page/premium-quality-moringa-face-oil-30ml',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100009',
//         brand: 'Vedriti',
//         title: 'Vedriti Wood Pressed Black Mustard Oil for Cooking, Naturally Cholesterol Free. Rich Aroma & Flavour of Real A1 Grade Mustard Seeds. Can Be Used in Daily Cooking. Purity in Every Drop, 1000 ML',
//         images: [
//             {
//                 imageName: '100009-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/3QAYAf1',
//             },
//             {
//                 title: 'Website',
//                 link: 'https://www.vedriti.in/products/pure-wood-pressed-black-mustard-oil?variant=46585221972244',
//             },
//         ],
//         categories: [DelishBowlCategory.Food, DelishBowlCategory.HealthBeauty],
//         isFeatured: false,
//         isAvailable: false,
//     },
//     {
//         id: '100007',
//         brand: 'Fresh Dew',
//         title: 'Fresh Dew Dark Spot Corrector Brightening Face Cream - With Alpha Arbutin, Kojic Acid and Niacinamide | Helps Reducing Dark Spots, Pigmentation, Sun Spots, Uneven Skin tone & Acne Marks',
//         images: [
//             {
//                 imageName: '100007-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/4gvfkz4',
//             },
//             {
//                 title: 'Flipkart',
//                 link: 'https://dl.flipkart.com/s/2jNsmmNNNN',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100017',
//         brand: 'Floradust',
//         title: '100% Pure Moringa Leaves & Drumstick Powder | Herbal Supplement for Immunity, Skin, Hair & Weight Management | Vitamins & Antioxidants',
//         images: [
//             {
//                 imageName: '100017-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/456rBI9',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty, DelishBowlCategory.Food],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     {
//         id: '100016',
//         brand: 'Vedriti',
//         title: 'Vedriti Wood Pressed White Sesame Oil, Cold Pressed, Kolhu/Kacchi Ghani, Chemical Free, Naturally Cholesterol Free, Sesame Oil with Rich Aroma & Flavour of Real Sesame Seeds, Can Be Used in Daily Cooking, Multipurpose Usage, A1 Grade Sesame Seeds, Purity in Every Drop',
//         images: [
//             {
//                 imageName: '100016-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/4jCQuyP',
//             },
//             {
//                 title: 'Website',
//                 link: 'https://www.vedriti.in/products/vedriti-wood-pressed-white-sesame-oil-cold-pressed-kolhu-kacchi-ghani-chemical-free-cold-pressed-white-sesame-oil-for-cooking-vedriti_sesame_oil_p?variant=46585226854676',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: false,
//         isAvailable: false,
//     },
//     {
//         id: '100015',
//         brand: 'Vedriti',
//         title: 'Vedriti Wood Pressed Coconut Oil, Cold Pressed, Kolhu/Kacchi Ghani, Chemical Free, Multipurpose Usage, A1 Grade Coconuts, Purity In Every Drop',
//         images: [
//             {
//                 imageName: '100015-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/3Gm1cvr',
//             },
//             {
//                 title: 'Website',
//                 link: 'https://www.vedriti.in/products/vedriti-wood-pressed-coconut-oil-cold-pressed-kolhu-kacchi-ghani-chemical-free-cold-pressed-coconut-oil-for-cooking-vedriti_coconut_oil_p?variant=46585225052436',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: false,
//         isAvailable: false,
//     },
//     {
//         id: '100014',
//         brand: 'RLB-CHOICE',
//         title: 'Rlb Choice-Detox Loose Leaves Green Tea-Your Path To Wellness-Purity In Every Sip, Better Digestion, Boost Immunity, Skin Glow',
//         images: [
//             {
//                 imageName: '100014-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.in/d/9HEwSap',
//             },
//             {
//                 title: 'Website',
//                 link: 'https://www.rlbchoice.com/product-page/detox-green-tea',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: false,
//         isAvailable: false,
//     },
//     {
//         id: '100013',
//         brand: 'Proskire',
//         title: 'Proskire Intense Hair Growth Serum with Redensyl, Anagain, Procapil, Capilia Longa, Biotin & Ashwagandha',
//         images: [
//             {
//                 imageName: '100013-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Amazon',
//                 link: 'https://amzn.to/44mAtc8',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
//     // {
//     //     id: '100012',
//     //     brand: 'Vedriti',
//     //     title: 'Vedriti Wood Pressed Groundnut Oil | Cold Pressed | Kolhu/Kacchi Ghani | Chemical Free | Cold Pressed Groundnut Oil for Cooking',
//     //     images: [
//     //         {
//     //             imageName: '100012-001.png',
//     //             isIcon: true,
//     //             backgroundColor: '#f4f4f4',
//     //         },
//     //     ],
//     //     links: [
//     //         {
//     //             title: 'Amazon',
//     //             link: 'https://amzn.to/4kJbxRJ',
//     //         },
//     //         {
//     //             title: 'Website',
//     //             link: 'https://www.vedriti.in/products/vedriti-wood-pressed-groundnut-oil-cold-pressed-kolhu-kacchi-ghani-chemical-free-cold-pressed-groundnut-oil-for-cooking-vedriti_groundnut_oil_p?variant=46585225871636',
//     //         },
//     //     ],
//     //     categories: [DelishBowlCategory.Food],
//     //     isFeatured: true,
//     //     available: true,
//     // },
//     // {
//     //     id: '100011',
//     //     brand: 'Ayuzera',
//     //     title: 'Ayuzera Himalayan Sea Buckthorn Pulp Concentrate 300ml | Liquid Supplements | Makes up to 50 Glass Juice (Rich in Vitamin C) | Lab Tested | Omega 3, 6, 7, and 9, and Antioxidants',
//     //     images: [
//     //         {
//     //             imageName: '100011-001.png',
//     //             isIcon: true,
//     //             backgroundColor: '#f4f4f4',
//     //         },
//     //     ],
//     //     links: [
//     //         {
//     //             title: 'Amazon',
//     //             link: 'https://amzn.to/4iss6j0',
//     //         },
//     //         {
//     //             title: 'Website',
//     //             link: 'https://ayuzera.com/products/product-details/ayuzera-himalayan-sea-buckthorn-pulp-juice-concentrate-300ml-with-999-pure-sea-buckthorn-pulp-/8908023909008',
//     //         },
//     //     ],
//     //     categories: [DelishBowlCategory.HealthBeauty],
//     //     isFeatured: true,
//     //     available: true,
//     // },
//     // {
//     //     id: '100010',
//     //     brand: 'Ayurica Herbal',
//     //     title: 'Ayurica Herbal 100% Natural Hair Shampoo with Methidana, Shikakai, Reetha and Amla Powder - 171g For Man And Women | Paraben And Sulphate Free Shampoo',
//     //     images: [
//     //         {
//     //             imageName: '100010-001.png',
//     //             isIcon: true,
//     //             backgroundColor: '#f4f4f4',
//     //         },
//     //     ],
//     //     links: [
//     //         {
//     //             title: 'Amazon',
//     //             link: 'https://amzn.in/d/bGLzqC1',
//     //         },
//     //         {
//     //             title: 'Website',
//     //             link: 'https://ayuricaherbal.com/product/natural-hair-shampoo/',
//     //         },
//     //     ],
//     //     categories: [DelishBowlCategory.HealthBeauty],
//     //     isFeatured: true,
//     //     available: true,
//     // },
//     // {
//     //     id: '100008',
//     //     brand: 'LAKMÉ',
//     //     title: 'Sun Expert Dry Matte Fluid SPF 50++++ Sunscreen with 1% niacinamide & ceramide, for oily skin & combination skin 50ml',
//     //     images: [
//     //         {
//     //             imageName: '100008-001.png',
//     //             isIcon: true,
//     //             backgroundColor: '#f4f4f4',
//     //         },
//     //     ],
//     //     links: [
//     //         {
//     //             title: 'Amazon',
//     //             link: 'https://amzn.to/3D3xLNl',
//     //         },
//     //     ],
//     //     categories: [DelishBowlCategory.HealthBeauty],
//     //     isFeatured: true,
//     //     available: true,
//     // },
//     {
//         id: '100003',
//         brand: 'Proskire',
//         title: 'Proskire 10% Vitamin C Serum With Hyaluronic Acid & Papaya Ext For Skin Brightening  (30 ml)',
//         images: [
//             {
//                 imageName: '100003-001.png',
//                 isIcon: true,
//                 backgroundColor: '#f4f4f4',
//             },
//         ],
//         links: [
//             {
//                 title: 'Flipkart',
//                 link: 'https://dl.flipkart.com/s/JytQ8GuuuN',
//             },
//         ],
//         categories: [DelishBowlCategory.HealthBeauty],
//         isFeatured: true,
//         isAvailable: true,
//     },
// ];

export const amazonInfluencerShopCarousalmages = [
    '001.png',
    '002.png',
    '003.png',
    '004.png',
    '005.png',
    '006.png',
    '007.png',
    '008.png',
];

export const contactOptions = [
    {
        method: ContactMethod.Email,
        address: 'mydelishbowl.letterbox@gmail.com',
        addressText: 'mydelishbowl.letterbox@gmail.com',
    },
    // {
    //     method: ContactMethod.Phone,
    //     address: '+919876122345',
    //     addressText: '9876122345',
    // },
];

export const socialProfiles = [
    {
        name: 'Instagram',
        platform: SocialPlatform.Instagram,
        followers: '1.4M',
        link: 'https://www.instagram.com/mydelishbowl',
    },
    {
        name: 'YouTube',
        platform: SocialPlatform.YouTube,
        followers: '819K',
        link: 'https://www.youtube.com/@mydelishbowl',
    },
    {
        name: 'Facebook',
        platform: SocialPlatform.Facebook,
        followers: '154K',
        link: 'https://www.facebook.com/mydelishbowl',
    },
    {
        name: 'Threads',
        platform: SocialPlatform.Threads,
        followers: '163K',
        link: 'https://www.threads.net/mydelishbowl',
    },
];
